// Utils
import { getDecimalNum } from "src/utils/number/numberHelper";

// Shared formatting for the legacy VF exam displays -- LegacyVFColumns,
// LegacyVFDetails, and LegacyVFCompactSummary all render the same
// underlying exam data, just at different sizes/layouts.

// Fixation Loss / False Positives / False Negatives always arrive as a
// fraction (0-1), so always scale up to a percentage.
export const formatAsPercentage = (value: number | undefined | null) => {
  if (value === undefined || value === null) return "N/A";
  return `${getDecimalNum(value * 100, 2)}%`;
};

// VFI can already arrive as a whole percentage (an integer), so only scale
// it up when it isn't one.
export const formatIndexAsPercentage = (value: number | undefined | null) => {
  if (value === undefined || value === null) return "N/A";
  const percentage = Number.isInteger(value) ? value : value * 100;
  return `${getDecimalNum(percentage, 2)}%`;
};

// Converts a raw enum-ish value (SNAKE_CASE or camelCase) into
// "Human Readable" display text.
export const toHumanReadable = (sentence: string | undefined | null) => {
  if (!sentence || typeof sentence !== "string") return "N/A";

  return sentence
    .replace(/_/g, " ") // Replace underscores with spaces
    .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space between camelCase words
    .toLowerCase() // Convert to lowercase
    .replace(/(^|\s)\S/g, (letter) => letter.toUpperCase()) // Capitalize the first letter of each word
    .trim(); // Remove extra spaces
};
